import * as yup from 'yup';

import * as MESSAGES from '../messages';

export const ActionSteponeSchema = yup.object().shape({
  name: yup.string().trim().required(MESSAGES.REQUIRE_MESSAGE),
});

export const ActionSteptwoSchema = yup.object().shape({
  selectedDataType: yup
    .string()
    .oneOf(['1', '2'], 'Please select atleast one')
    .required(MESSAGES.REQUIRE_MESSAGE),
  selecetedDimension: yup.string().required(MESSAGES.REQUIRE_MESSAGE),
  selectedColumnOption: yup.string().required(MESSAGES.REQUIRE_MESSAGE),
});
export const ActionSteptwoSchemaDataType = yup.object().shape({
  selectedDataType: yup
    .string()
    .oneOf(['1', '2', '3'], 'Please select at least one data type')
    .required(MESSAGES.REQUIRE_MESSAGE),
  selectedBlock: yup
    .mixed()
    .when('selectedDataType', (selectedDataType, schema) =>
      selectedDataType === '2' || selectedDataType === '3'
        ? schema.test(
            'required',
            'Please select at least one block',
            (value: unknown) => value != null && value !== '',
          )
        : schema,
    ),
  selectedScenario: yup
    .mixed()
    .when('selectedDataType', (selectedDataType, schema) =>
      selectedDataType === '2' || selectedDataType === '3'
        ? schema.test(
            'required',
            'Please select at least one scenario',
            (value: unknown) => value != null && value !== '',
          )
        : schema,
    ),
});

export const ActionDataStepTwoSchema = yup.object().shape({
  selectedDataPeriod: yup
    .string()
    .oneOf(['1', '2'], 'Please select atleast one')
    .required(MESSAGES.REQUIRE_MESSAGE),
});
export const ActionDataStepTwoSchemaTimePeriod = yup.object().shape({
  selectedTimePeriod: yup
    .string()
    .oneOf(['row', 'column'], 'Please select atleast one')
    .required(MESSAGES.REQUIRE_MESSAGE),
});

export const ActionStepthreeSchema = yup.object().shape({
  name: yup.string().trim().required(MESSAGES.REQUIRE_MESSAGE),
});
